export default "__VITE_ASSET__DUlp6zOe__"